import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDown, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';
import "./CheckList.css";

const CheckList = () => {
    const [tasks, setTasks] = useState(JSON.parse(localStorage.getItem('tasks')) || []);
    const [newTask, setNewTask] = useState({ name: "", description: "", category: "", Start_date: "", End_date: "" });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [viewTask, setViewTask] = useState(null);
    const [taskIndex, setTaskIndex] = useState(null);
    const [activeModal, setActiveModal] = useState(null); // 'addTask' or 'viewTask'
    const [selectedCategory, setSelectedCategory] = useState("All Tasks"); // Track selected category

    useEffect(() => {
        localStorage.setItem('tasks', JSON.stringify(tasks));
    }, [tasks]);

    const addTask = () => {
        if (newTask.name.trim()) {
            setTasks([...tasks, { ...newTask, completed: false }]);
            setNewTask({ name: "", description: "", category: "", Start_date: "", End_date: "" });
            setIsModalOpen(false);
        }
    };

    const deleteTask = (index) => {
        const updatedTasks = tasks.filter((task, i) => i !== index);
        setTasks(updatedTasks);
    };

    const toggleComplete = (index) => {
        const updatedTasks = tasks.map((task, i) =>
            i === index ? { ...task, completed: !task.completed } : task
        );
        setTasks(updatedTasks);
    };

    const openAddTaskModal = () => {
        setActiveModal('addTask');
        setIsModalOpen(true);
    };

    const openViewTaskModal = (task, index) => {
        setViewTask(task);
        setTaskIndex(index);
        setActiveModal('viewTask');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setViewTask(null);
        setTaskIndex(null);
        setActiveModal(null);
    };

    const downloadTasksAsExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(tasks);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tasks");

        XLSX.writeFile(workbook, "Tasks.xlsx");
    };

    const handlePrint = () => {
        window.print();
    };

    const pendingTasks = tasks.filter(task => !task.completed).length;
    const doneTasks = tasks.filter(task => task.completed).length;
    const completedPercentage = tasks.length ? (doneTasks / tasks.length) * 100 : 0;

    // Get unique categories
    const categories = [...new Set(tasks.map(task => task.category).filter(cat => cat))];

    // Filter tasks based on selected category
    const filteredTasks = selectedCategory === "All Tasks"
        ? tasks
        : tasks.filter(task => task.category === selectedCategory);

    return (
        <section id='whole-container' >
            <div className='checklist-maincontainer container'>
                <div className="  row align-items-center mt-5 mb-5">
                    <div className="centered-container">
                        <h2 className="section-heading" data-aos="zoom-in-down" data-aos-delay="100" data-aos-duration="900">
                            CheckList Management
                        </h2>
                       
                    </div>
                    <div className='working-container'>
                        <div className='top-container'>
                            <div className='side-heading'>
                                <h3>Checklist</h3>
                            </div>
                            <div className='right-heading'>
                                <div>
                                    <h3>You have completed <strong>{doneTasks} out of {tasks.length}</strong> tasks</h3>
                                    <div className="loading-bar">
                                        <div
                                            className="loading-bar-fill"
                                            style={{ width: `${completedPercentage}%` }}
                                        >
                                            {Math.round(completedPercentage)}%
                                        </div>
                                    </div>
                                </div>
                                <div className='option-section'>
                                    <div className='download-option' onClick={downloadTasksAsExcel}>
                                        <FontAwesomeIcon icon={faCircleDown} />
                                        <h4>Download</h4>
                                    </div>
                                    <div className='print-option' onClick={handlePrint}>
                                        <FontAwesomeIcon icon={faPrint} />
                                        <h4>Print</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='down-main-container'>
                            <div className='left-side'>
                                <div className='search'>
                                    <h3>Your Search</h3>
                                    {selectedCategory && (
                                        <div className="selected-category-display">
                                            <span>{selectedCategory}</span>
                                            {selectedCategory !== "All Tasks" && (
                                                <FontAwesomeIcon
                                                    icon={faTimes}
                                                    className="close-icon"
                                                    onClick={() => setSelectedCategory("All Tasks")}
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="status-section">
                                    <h3>Status</h3>
                                    <ul>
                                        <li className="pending">Pending: {pendingTasks}</li>
                                        <li className="done">Done: {doneTasks}</li>
                                        {/* Display categories */}
                                    </ul>
                                </div>
                                {categories.length > 0 && (
                                    <div className='category-section'>
                                        <h3>Categories</h3>
                                        <ul>
                                            <li
                                                id='category-value'
                                                className={selectedCategory === "All Tasks" ? 'selected-category' : ''}
                                                onClick={() => setSelectedCategory("All Tasks")}
                                            >
                                                All Tasks: {tasks.length}
                                            </li>
                                            {categories.map((category, index) => {
                                                // Count the number of tasks for each category
                                                const categoryCount = tasks.filter(task => task.category === category).length;
                                                return (
                                                    <li
                                                        key={index}
                                                        id='category-value'
                                                        className={selectedCategory === category ? 'selected-category' : ''}
                                                        onClick={() => setSelectedCategory(category)}
                                                    >
                                                        {category}: {categoryCount}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}

                            </div>
                            <div className='todo-list'>
                                <h2>Tasks Management</h2>
                                <div className="add-task-container">
                                    <input
                                        type="text"
                                        id="new-task-input"
                                        placeholder="Add a new task"
                                        onClick={openAddTaskModal}
                                    />
                                    <button
                                        id="add-task-btn"
                                        onClick={openAddTaskModal}
                                    >
                                        <i className="fa fa-plus"></i>
                                    </button>
                                </div>
                                <ul>
                                    {filteredTasks.map((task, index) => (
                                        <li
                                            key={index}
                                            onClick={() => openViewTaskModal(task, index)}
                                            className={`task-item ${task.completed ? 'completed' : ''}`}
                                        >
                                            {task.name}
                                            <div>
                                                <button
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        toggleComplete(index);
                                                    }}
                                                    className="complete-task-btn"
                                                >
                                                    ✓
                                                </button>
                                                <button
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        deleteTask(index);
                                                    }}
                                                    className="delete-task-btn"
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {isModalOpen && activeModal === 'addTask' && (
                    <div id='tasking-modal' className="task-modal">
                        <div className="task-modal-content">
                            <span className="close-btn" onClick={closeModal}>×</span>
                            <h2>Add New Task</h2>
                            <label htmlFor="name" className='starting-date'>Name of task</label>
                            <input
                                id='name'
                                type="text"
                                className="modal-input"
                                value={newTask.name}
                                onChange={(e) => setNewTask({ ...newTask, name: e.target.value })}
                            />
                            <label htmlFor="description" className='starting-date'>Description of task</label>
                            <textarea
                                id='description'
                                className="modal-textarea"
                                value={newTask.description}
                                onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
                            />
                            <label htmlFor="Select-Category" className='starting-date'>Select Category</label>
                            <select
                                id='Select-Category'
                                className="modal-input"
                                value={newTask.category}
                                onChange={(e) => setNewTask({ ...newTask, category: e.target.value })}
                            >
                                <option value="">-- Select Category --</option>
                                <option value="Wedding Venue">Wedding Venue</option>
                                <option value="Photography">Photography</option>
                                <option value="Wedding Clothes">Wedding Clothes</option>
                                <option value="Shopping">Shopping</option>
                                <option value="Wedding Makeup">Wedding Makeup</option>
                                <option value="Events">Events</option>
                                <option value="Catering">Catering</option>
                                <option value="Photography and Video">Photography and Video</option>
                                <option value="Planning">Planning</option>
                                <option value="Jewellery">Jewellery</option>
                                <option value="Transportation">Transportation</option>
                            </select>
                            <label htmlFor="Start_date" className='starting-date'>Start Date</label>
                            <input
                                id='Start_date'
                                type="date"
                                className="modal-input"
                                value={newTask.Start_date}
                                onChange={(e) => setNewTask({ ...newTask, Start_date: e.target.value })}
                            />
                            <label htmlFor="End_date" className='starting-date'>End Date</label>
                            <input
                                id='End_date'
                                type="date"
                                className="modal-input"
                                value={newTask.End_date}
                                onChange={(e) => setNewTask({ ...newTask, End_date: e.target.value })}
                            />
                            <button onClick={addTask} className="create-task-btn">Create</button>
                        </div>
                    </div>
                )}

                {isModalOpen && activeModal === 'viewTask' && viewTask && (
                    <div id='viewing-task-modal' className="view-task-modal">
                        <div className="view-task-content">
                            <div className='close-header'>
                                <span className="close-btn" onClick={closeModal}>×</span>
                            </div>
                            <div className="task-details">
                                <h2 className="task-title">{viewTask.name}</h2>
                                <p className="task-description">{viewTask.description}</p>
                                <div className="task-meta">
                                    <span className="task-category">
                                        <i className="fa fa-tag"></i> {viewTask.category}
                                    </span>
                                    <span className="task-dates">
                                        <i className="fa fa-calendar"></i> From {viewTask.Start_date} to {viewTask.End_date}
                                    </span>
                                </div>
                            </div>
                            <div className="task-header">
                                <button
                                    className="mark-complete-btn"
                                    onClick={() => {
                                        toggleComplete(taskIndex);
                                        closeModal();
                                    }}>
                                    <i className="fa fa-check-circle"></i> Mark complete
                                </button>
                                <button
                                    className="remove-task-btn"
                                    onClick={() => {
                                        deleteTask(taskIndex);
                                        closeModal();
                                    }}>
                                    <i className="fa fa-trash"></i> Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default CheckList;
